import gql from 'graphql-tag'

/*
  Used for GraphQL Type/Hooks generation and Apollo caching.
*/

export const CREATE_USERS = gql`
  mutation createUsers($input: CreateUsersInput!) {
    createUsers(input: $input) {
      appUserId
      effectivePermissions
      firstName
      lastName
    }
  }
`

export const GET_SELF = gql`
  query self {
    self {
      id
      permissions
      adminUser {
        id
        appUserId
        sub
        email
        firstName
        lastName
      }
      studentUser {
        id
        appUserId
        sub
        email
        displayName
        firstName
        lastName
        name
        studentId
      }
    }
  }
`

export const SCHEDULER_LOGIN = gql`
  mutation schedulerLogin($input: CreateSchedulerLoginInput!) {
    schedulerLogin(input: $input) {
      key
    }
  }
`
